<h2 class="headerTitle">
    {{'cart_header' | translate}}
    <div class="line"></div>
</h2>
<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
        <app-cart [readonly]="this.isSummaryPage" (changePrice)="onChangePrice($event)"></app-cart>
    </div>
</div>


<div *ngIf="!isLogin">
    <div class="ui-g" style="margin-top: 25px;">
        <div class="ui-sm-12 ui-md-6 ui-lg-6 ui-xl-6"><app-authorization (loginEmitter)="onLogin($event)"  [redirectValidLogin]="'/koszyk'"></app-authorization></div>
        <div class="ui-sm-12 ui-md-6 ui-lg-6 ui-xl-6"><app-register (registerEmitter)="onRegister($event)" [redirectValidLogin]="'/koszyk'"></app-register></div>
    </div>
</div>

<div *ngIf="totalPrice && isLogin">
    <div class="ui-g">
        <div class="ui-sm-12 ui-md-12 ui-lg-8 ui-xl-8">
            <p-panel header="{{'invoice_details' | translate}}">
                <invoice-details-list (invoicesList)="fetchedInvoices($event)" [readonly]="this.isSummaryPage" (onChangeInvoice)="changeInvoice($event)"></invoice-details-list>
                <div class="validate_error" *ngIf="this.invoicesList.length > 0 && invoiceSelected == null">{{'cart_validate_data_invoice' | translate}}</div>
            </p-panel>
        </div>


        <div class="ui-sm-12 ui-md-12 ui-lg-4 ui-xl-4">
            <div style="margin-bottom: 20px;">
                <p-panel header="{{'payment_type' | translate}}">
                    <app-payment-type [readonly]="this.isSummaryPage" (changePaymentMethod)="onSelectPaymentMethod($event)"></app-payment-type>
                    <div class="validate_error" *ngIf="paymentMethod.code == null">{{'cart_validate_payments' | translate}}</div>

                    <div *ngIf="paymentMethod.code == 'payu' || paymentMethod.code == 'paypal'" style="display: block;margin-bottom: 10px;" [innerHTML]="'info_order_process_online' | translate"></div>
                    <div *ngIf="paymentMethod.code == 'transfer'" style="display: block;margin-bottom: 10px;" [innerHTML]="'info_order_process_transfer' | translate"></div>
                    <div *ngIf="paymentMethod.code == 'prepaid'" style="display: block;margin-bottom: 10px;" [innerHTML]="'info_order_process_prepaid' | translate"></div>

                </p-panel>
            </div>

            <p-panel header="{{'cart_summary_price' | translate}}">
                <div *ngIf="isLogin" style="margin-top: 10px">
                    <div>{{'cart_total_amount' | translate}}: <b>{{totalPrice | currencyReduce | currency: selectedCurrency}}</b></div> <br/>
                    <app-loader *ngIf="processingOrder"></app-loader>

                    <div *ngIf="this.isSummaryPage" style="margin-bottom: 10px;">
                        <div style="font-size: 12px;display: block;margin-bottom: 10px;" [innerHTML]="'info_order_process' | translate"></div>
                        <p-checkbox id="agree" [binary]="true" [(ngModel)]="acceptedAgreement"></p-checkbox>
                        <label for="agree">
                            
                            &nbsp;<span>{{"accept_agreement1" | translate}}</span>&nbsp;<span class="agreement" (click)="this.openAgreement()">{{"accept_agreement2" | translate}}</span>&nbsp;<span>{{"accept_agreement3" | translate}}</span>
                        </label>
                    </div>



                    <button *ngIf="!this.isSummaryPage" [disabled]="invoiceSelected == null || paymentMethod.code == null" style="width: 100%;" pButton type="button" (click)="onCreatePrimaryPage()" label="{{'cart_submit_confirm' | translate}}" class="ui-button-raised ui-button-success"></button>
                    <button *ngIf="this.isSummaryPage && !processingOrder" [disabled]="(invoiceSelected == null || paymentMethod.code == null) || (!acceptedAgreement)"  style="width: 100%;" pButton type="button" (click)="onCreateOrder()" label="{{'cart_submit_order' | translate}}" class="ui-button-raised ui-button-success"></button>
                </div>
            </p-panel>


        </div>

    </div>
</div>


<p-dialog header=" " [(visible)]="displayError" [style]="isMobile ? {width: '90vw'} : {width: '50vw'}">
   <div>{{'cart_errorMessage' | translate}}</div>
   <div *ngFor="let item_ of errorItems">
    {{item_.title}}
   </div>
</p-dialog>

<p-dialog header="{{'terms_and_conds' | translate}}" [(visible)]="isOpenAgreement" [style]="{width: '80vw'}">
    <div>
        <div [innerHTML]="agreementHtml"></div>
    </div>
 </p-dialog>
